import { render, staticRenderFns } from "./StudentConfirmDone.vue?vue&type=template&id=4ee7ce33&scoped=true&lang=pug&"
import script from "./StudentConfirmDone.vue?vue&type=script&lang=ts&"
export * from "./StudentConfirmDone.vue?vue&type=script&lang=ts&"
import style0 from "./StudentConfirmDone.vue?vue&type=style&index=0&id=4ee7ce33&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee7ce33",
  null
  
)

export default component.exports